import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _58c2059e = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _4788fc32 = () => interopDefault(import('../pages/misc/call-error.vue' /* webpackChunkName: "pages/misc/call-error" */))
const _715bf73a = () => interopDefault(import('../pages/misc/call-rating.vue' /* webpackChunkName: "pages/misc/call-rating" */))
const _7c694fa6 = () => interopDefault(import('../pages/misc/call-success.vue' /* webpackChunkName: "pages/misc/call-success" */))
const _a4cb692a = () => interopDefault(import('../pages/misc/inbound-error.vue' /* webpackChunkName: "pages/misc/inbound-error" */))
const _42822ca8 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _cb62beee = () => interopDefault(import('../pages/conference/_key.vue' /* webpackChunkName: "pages/conference/_key" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/help",
    component: _58c2059e,
    name: "help"
  }, {
    path: "/misc/call-error",
    component: _4788fc32,
    name: "misc-call-error"
  }, {
    path: "/misc/call-rating",
    component: _715bf73a,
    name: "misc-call-rating"
  }, {
    path: "/misc/call-success",
    component: _7c694fa6,
    name: "misc-call-success"
  }, {
    path: "/misc/inbound-error",
    component: _a4cb692a,
    name: "misc-inbound-error"
  }, {
    path: "/",
    component: _42822ca8,
    name: "index"
  }, {
    path: "/conference/:key?",
    component: _cb62beee,
    name: "conference-key"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
